import React from "react";
import { FaGlobeAsia, FaGlobeEurope, FaGlobeAfrica, FaFlag } from "react-icons/fa";

const ExportCountries = () => {
  return (
    <div className="bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 py-12">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          200+ Deliveries Worldwide
        </h2>
        <p className="text-gray-600 mb-10">
          Serving happy customers across India, Asia, Europe, and Africa.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

          {/* India */}
          <div className="flex flex-col items-center">
            <div className="bg-emerald-500/10 p-4 rounded-full mb-3">
              <FaFlag className="text-emerald-600 text-4xl" />
            </div>
            <h3 className="font-semibold text-gray-700">India</h3>
          </div>

          {/* Asia */}
          <div className="flex flex-col items-center">
            <div className="bg-emerald-500/10 p-4 rounded-full mb-3">
              <FaGlobeAsia className="text-emerald-600 text-4xl" />
            </div>
            <h3 className="font-semibold text-gray-700">Asia</h3>
          </div>

          {/* Europe */}
          <div className="flex flex-col items-center">
            <div className="bg-emerald-500/10 p-4 rounded-full mb-3">
              <FaGlobeEurope className="text-emerald-600 text-4xl" />
            </div>
            <h3 className="font-semibold text-gray-700">Europe</h3>
          </div>

          {/* Africa */}
          <div className="flex flex-col items-center">
            <div className="bg-emerald-500/10 p-4 rounded-full mb-3">
              <FaGlobeAfrica className="text-emerald-600 text-4xl" />
            </div>
            <h3 className="font-semibold text-gray-700">Africa</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportCountries;